import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useUserUpdates } from "~context/UserUpdatesContext/UserUpdatesContext.tsx";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import type { Notification } from "~types/notification.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useDeleteNotification = () => {
  const queryClient = useQueryClient();
  const request = useApi();
  const { refetch: refetchUserUpdates } = useUserUpdates();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (notificationKey: string) =>
      await request(`notifications/${notificationKey}`, {
        method: "DELETE",
      }),
    onSuccess: (response: DefaultOperationSuccessResponse, notificationKey: string) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        queryClient.setQueryData<Array<Notification>>(
          ["notifications"],
          (oldValues) => oldValues?.filter((item) => item.key !== notificationKey) || [],
        );
        refetchUserUpdates();
      }
    },
  });
};
